import { FaEye, FaFilePen } from "react-icons/fa6";
import SubHeading from "../../atoms/SubHeading";
import IconButton from "../../atoms/IconButton";
import { useSession } from "../../../context/SessionContext";

const InmuebleArchivoCard = ({ doc, onClickEdit, onClickView }) => {
    const { user } = useSession();

    return (
        <div
            className="h-52 w-full flex flex-col justify-around items-center bg-gradient-to-b from-rs-azul via-rs-azul/85 to-rs-azul/60 rounded-lg"
        >
            <SubHeading text={doc?.name || "Documento no encontrado"} />
            <div className="w-full flex flex-row justify-around">
                <IconButton
                    icon={FaEye}
                    bgColor="bg-rs-azul"
                    size="min-w-20 max-w-20"
                    iconSize="text-5xl"
                    onClick={onClickView}
                />
                {user && user?.role !== "Resident" ?
                    <IconButton
                        icon={FaFilePen}
                        bgColor="bg-rs-rojo"
                        size="min-w-20 max-w-20"
                        iconSize="text-5xl"
                        onClick={onClickEdit}
                    />
                :
                    null
                }
            </div>
        </div>
    );
};

export default InmuebleArchivoCard;